const EventEmitter = require('eventemitter3');


const _init = function (ui) {

    ui.id = ui.el.dataset.targetId;

};

const _enable = function () {
    const ui = this;
    if (ui._enabled) return;
    ui.el.dataset.active = true;
    _addEventListeners(ui);
    ui._enabled = true;
};

const _disable = function () {
    const ui = this;
    if (!ui._enabled) return;
    ui.el.dataset.active = false;
    _addEventListeners(ui, false);
    ui._enabled = false;
};

const _destroy = function () {
    const ui = this;
    ui.disable();
    ui.removeAllListeners();

    delete ui.el.data.uiController;
};

const _addEventListeners = function (ui, b) {

    if (b === false) {
        ui.el.removeEventListener('click', ui._onClick);
        return;
    }

    ui._onClick = () => {
        ui.emit('go');
    };

    ui.el.addEventListener('click', ui._onClick);
};

module.exports = el => {

    if (el.data && el.data.uiController) return el.data.uiController;

    const ui = new EventEmitter();
    ui.el = el;
    ui.counter = 1;
    ui.total = 0;

    ui.el.data = ui.el.data || {};
    ui.el.data.uiController = ui;

    ui.type = 'counter-button';
    ui.enable = _enable.bind(ui);
    ui.disable = _disable.bind(ui);
    ui.destroy = _destroy.bind(ui);
    ui.setValue = value => {
        ui.counter = value;
        ui.el.dataset.counter = value;
        ui.el.dataset.isLast = ui.total === ui.counter;
    };
    ui.setTotal = value => {
        ui.total = value;
        ui.el.dataset.total = value;
        ui.el.dataset.isLast = ui.total === ui.counter;
    };

    _init(ui);

    return ui;
}


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/ui/CounterButton.js